export default "__VITE_ASSET__D0Y$UD2F__"